export default class ModalAccessibility {
    static handleModalTabbing(modal, customFocusableElementClassesIds, keyboardEvent) {
        customFocusableElementClassesIds =
            customFocusableElementClassesIds.length > 0
                ? ", " + customFocusableElementClassesIds
                : "";
        const focusableElements = modal.querySelectorAll("a, button, input, select, textarea, [tabindex='0']" +
            customFocusableElementClassesIds);
        if (focusableElements.length === 0) {
            return;
        }
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];
        const firstHasFocus = firstFocusableElement === document.activeElement;
        const lastHasFocus = lastFocusableElement === document.activeElement;
        if (keyboardEvent.key == "Tab") {
            if (keyboardEvent.shiftKey) {
                // if shift-tab keys are pressed (tabbing backwards)
                if (firstHasFocus) {
                    lastFocusableElement.focus();
                    keyboardEvent.preventDefault();
                }
            }
            else {
                // if tab key is pressed (tabbing forwards)
                if (lastHasFocus) {
                    firstFocusableElement.focus();
                    keyboardEvent.preventDefault();
                }
            }
        }
    }
}
